import React from "react";

import * as R from "ramda";

import { connect } from "react-redux";
import { getters, actions } from "../model";

import { Div, FontIcon, Text3 } from "components/Base";

import PopoverMenu from "Portal/NewPortal/Shared/Popover";

import FilterLabel from "./FilterLabel";
import { noop } from "utils/General";
import { getAccentColor } from "Portal/NewPortal/PortalHome/selectors";

const decorate = connect(
  state => ({
    filters: getters.filters(state),
    accentColor: getAccentColor(state)
  }),
  {
    selectFilters: actions.selectFilters
  }
);

const FilterBy = ({ filters, selectFilters, accentColor }) => (
  <PopoverMenu
    Trigger={
      <Div
        display="row.center.center"
        color={accentColor || "#4263EB"}
        style={{ gap: "6px" }}
      >
        <FontIcon color={accentColor || "#4263EB"} fs={3}>
          filter_list
        </FontIcon>
        <Text3 color={accentColor || "#4263EB"} fw={3}>
          Filter
        </Text3>
        <FontIcon color={accentColor || "#4263EB"} fs={3}>
          arrow_drop_down
        </FontIcon>
      </Div>
    }
    options={R.map(
      g => ({
        id: g.id,
        label: <FilterLabel color={accentColor || "#4263EB"} {...g} />,
        callback: g.selected ? noop : () => selectFilters(g.id)
      }),
      filters
    )}
  />
);

export default decorate(FilterBy);
